import { jsx } from 'react/jsx-runtime';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';

function TableLoadingBody(props) {
  return /* @__PURE__ */ jsx("tbody", { "data-testid": "loading-indicator", children: /* @__PURE__ */ jsx("tr", { children: /* @__PURE__ */ jsx("td", { colSpan: props.colSpan, children: /* @__PURE__ */ jsx(
    Box,
    {
      sx: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        minHeight: "15rem"
      },
      children: /* @__PURE__ */ jsx(CircularProgress, { size: "5rem" })
    }
  ) }) }) });
}

export { TableLoadingBody };
//# sourceMappingURL=TableLoadingBody.esm.js.map
